import { darken } from 'polished';
import React from 'react';
import styled, { css } from 'styled-components';
import { Box } from '../Box';
import { Icon } from '../Icon';
import { Text } from '../Text';
import { theme } from '../theme';
import { focusOutlineStyle } from '../utils/focusOutline';
export const Card = ({ children, leadingIcon, title, body, visual, tag, cardOnClickAction, rightAction, buttonAction, fallbackStyle = false, visualHeight = '', className = '', maxWidth = '', marginX = '', marginY = '', narrow = false, wide = false, ...otherProps }) => {
    const addChildMargin = (!!leadingIcon || !!title || !!body) && children;
    const isNotClickable = !cardOnClickAction;
    return (React.createElement(Container, { className: className, "$maxWidth": maxWidth, "$marginX": marginX, "$marginY": marginY, "$narrow": narrow, "$wide": wide, "$visual": visual, "$fallbackStyle": fallbackStyle, "$isNotClickable": isNotClickable, onClick: cardOnClickAction, tabIndex: isNotClickable ? undefined : 0, ...otherProps },
        tag && visual && React.createElement(TagWrapper, null, tag),
        visual && (React.createElement(VisualWrapper, { "$visualHeight": visualHeight },
            React.createElement(Visual, { "$visualUrl": visual, "$visualHeight": visualHeight }))),
        React.createElement(Box, { p: visual ? '16px' : { custom: '0px' } },
            React.createElement(Box, { flex: true, alignItems: "center", justifyContent: "space-between" },
                React.createElement(Box, { flex: true, alignItems: "center" },
                    leadingIcon && (React.createElement(Icon, { mr: "12px", render: leadingIcon, size: 24, color: "liquorice" })),
                    React.createElement(Box, null,
                        title && (React.createElement(Text, { typo: "headline-regular", color: "liquorice" }, title)),
                        body && (React.createElement(Text, { typo: "body-regular", color: "sesame" }, body)))),
                rightAction && rightAction),
            React.createElement(Box, { mt: addChildMargin ? '16px' : { custom: '0px' } }, children),
            buttonAction && React.createElement(Box, { mt: "16px" }, buttonAction))));
};
const Container = styled(Box) `
  background: ${({ $fallbackStyle }) => $fallbackStyle ? theme.colors.cream : theme.colors.custard};
  box-sizing: border-box;
  border-radius: 16px;

  max-width: ${(p) => p.$maxWidth};
  margin-top: ${(p) => p.$marginY};
  margin-right: ${(p) => p.$marginX};
  margin-bottom: ${(p) => p.$marginY};
  margin-left: ${(p) => p.$marginX};

  padding: ${({ $visual }) => ($visual ? '0px' : '16px')};
  position: relative;
  overflow: hidden;

  ${({ $isNotClickable, $fallbackStyle }) => !$isNotClickable &&
    css `
      cursor: pointer;
      &:hover {
        background: ${darken(0.1, $fallbackStyle ? theme.colors.cream : theme.colors.custard)};
      }

      ${focusOutlineStyle}
    `};
`;
const TagWrapper = styled(Box) `
  position: absolute;
  top: 12px;
  right: 12px;
`;
const VisualWrapper = styled(Box) `
  width: 100%;
  margin-top: -16px;

  ${({ $visualHeight }) => $visualHeight && `height: ${$visualHeight};`}
`;
const Visual = styled(Box) `
  width: 100%;
  background-image: url('${(p) => p.$visualUrl}');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  ${({ $visualHeight }) => $visualHeight ? `height: ${$visualHeight};` : 'padding-top: 100%;'}
`;
//# sourceMappingURL=Card.js.map